export default __webpack_public_path__ + "static/media/SCDLogo.97f199c9.png";